import React, { ForwardRefRenderFunction, forwardRef } from 'react';
import { Card } from 'components/Card';
import { SearchRecording } from 'features/search/searchSlice';

interface SearchResultRecordingProps {
  lastElement: boolean;
  result: SearchRecording;
}

const SearchResultRecording: ForwardRefRenderFunction<
  HTMLLIElement,
  SearchResultRecordingProps
> = (props, ref) => {
  return (
    <li className="col-xss-12 col-xs-6" ref={props.lastElement ? ref : null}>
      <Card
        id={props.result.id}
        url={`/recordings/${props.result.id}`}
        title={props.result.title}
        artworkKey={props.result.artworkKey}
        artworkMode={'recording'}
        type={'recording'}
      />
    </li>
  );
};

export default forwardRef<HTMLLIElement, SearchResultRecordingProps>(
  SearchResultRecording
);
